import { useEffect } from "react";
import { OpenFigisCard } from "./card";
import { setDocumentTitle } from "@/lib/documentTitle";

import { Route, Routes } from "react-router-dom";

import { OpenFigisTable } from "./table";

export default function OpenFigi() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Figis ouvertes");
  }, []);

  return (
    <Routes>
      <Route index element={<OpenFigisTable />} />
      <Route path=":id" element={<OpenFigisCard />} />
    </Routes>
  );
}
